const Priv = {
    metadata: {
        name: "priv",
        theme: "#1070E0",
        gradient: "#F2F9FF",
        display: "yes"
    },
    header: {
      name: "Consent Experiences Team",
      catchphrase: "Helping teams ship consent experiences across all apps and surfaces.",
      descriptions: {
        titles: ["COMPANY", "DATE"],
        contents: ["Meta", "Mar 2022 – Dec 2024"]
      },
      images: [
        // require('./Placeholder.png')
      ]
    },
    sections: [
      {
        type: "text",
        name: "Context",
        content: [
          "Privacy is an ever-evolving space, shaped by a growing body of global regulations and platform-level interface guidelines. The Consent team focused on creating design and engineering frameworks to help product teams across Meta's Family of Apps ship consent experiences that are compliant, consistent, and — most importantly — help users make informed decisions."
        ]
      },{
        type: "text",
        name: "Role",
        content: [
          "As the design lead of the team, I led the product strategy and design of the Consent UI Framework — an end-to-end product development framework that powered 80% of Meta's consents and saved 23.6 engineering years of build time. Alongside this, I established Consent UX Standards to drive consistency and quality across teams, and supported responses to major regulatory requirements including the Digital Markets Act, ePrivacy Directive, and CCPA.",
          "To learn more about my work on this team, feel free to reach out to me."
        ]
      }
    ]
  };

export default Priv;